import { Box } from '@mui/material';

import AuthLayout from '@layouts/authLayout/Auth.layout';
import StaffRegister from '@components/login/staff/register';

const StaffRegisterPage = () => {
  return (
    <Box display="flex" width="100%">
      <AuthLayout>
        <StaffRegister />
      </AuthLayout>
    </Box>
  );
};

export default StaffRegisterPage;
